import { fromNow } from '~/utils/date'

/** Relative last-sync time for the Overview metadata row; "Never" when unsynced. */
export function knowledgeSyncLabel(lastSyncedAt: string | null): string {
  return lastSyncedAt ? fromNow(lastSyncedAt) : 'Never'
}
